"use client";
import React, { useEffect, useState } from "react";
import CommonImage from "@/components/common/image/CommonImage";
import Image from "next/image";
import { FaPlay } from "react-icons/fa6";
import { Empty, Pagination } from "antd";
import CustomPagination from "@/components/common/Pagination/CustomPagination";
import HomePageService from "@/services/api/HomeService";
import PlayYoutubeModal from "@/components/common/Modal/PlayYoutubeModal";
import { usePublicFetch } from "@/hook/usePublicFetch";
import ReviewModal from "@/components/common/Modal/ReviewModal";

export default function SuccessStories() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const openModal = (video) => {
    setSelectedStory(video);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedStory(null);
  };

  const { data: successStoriesResponse, isLoading: loading } = usePublicFetch(
    ["success-stories", currentPage],
    () => HomePageService.getSuccessStories({ page: currentPage }),
    {},
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 15 * 60 * 1000,
      keepPreviousData: true,
    }
  );

  const successStories = successStoriesResponse?.data || [];
  const totalItems = successStoriesResponse?.total || 0;

  // console.log("successStories", successStories);

  return (
    <section className="success-stories-page_section bg-animation success_stories-section section_padding">
      <div className="container">
        <div className="section-title-wrap">
          <div className="section_title">
            <h2 className="title">
              <span className="w-8 h-8">
                <CommonImage
                  src="/images/admission-icon/success-icon.png"
                  className="img-icon"
                  alt="Book Icon"
                />
              </span>
              সাফল্যের শীর্ষে যারা
            </h2>
            <p className="short-des">
              ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
              গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
              মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
            </p>
          </div>
        </div>

        <div className="section-content-wrap">
          {successStories?.length > 0 ? (
            <div className="grid grid-cols-2 md:gap-6 gap-4">
              {successStories.map(function (story, index) {
                return (
                  <div className="success-stories-card" key={index}>
                    <div className="student-image-wrap">
                      <CommonImage
                        src={
                          story.profile_pic ??
                          "/images/home/success-student.png"
                        }
                        alt="Image"
                        className="success-student-image"
                      /> 
                      <button
                        className="video-play-btn"
                        onClick={() => openModal(story)}
                      >
                        <span>
                          <FaPlay className="icon" />
                        </span>
                        {story?.type == "Video"
                          ? " ভিডিও  দেখুন"
                          : " রিভিউ দেখুন"}
                      </button>
                    </div>
                    <div className="success-student-information">
                      <h2 className="name">{story.name}</h2>
                      <p className="text unit">ইউনিটঃ {story.unit}</p>
                      {story?.subject && (
                        <p className="text">বিষয়ঃ {story.subject}</p>
                      )}
                      <p className="text">
                        <span>সেশনঃ {story.session}</span>
                        <span>মেধা অবস্থানঃ {story.position}</span>
                      </p>
                      <p className="text">{story.university}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="items-center justify-center w-full">
              <Empty description="No Data Found" />
            </div>
          )}
          <CustomPagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalItems={totalItems}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      {selectedStory?.type == "Video" && (
        <PlayYoutubeModal
          modalOpen={modalOpen}
          closeModal={closeModal}
          link={selectedStory?.video_link}
        />
      )}
      {(!selectedStory?.type ||
        selectedStory?.type === "Text" ||
        selectedStory?.type === "Image") && (
        <ReviewModal
          modalOpen={modalOpen}
          closeModal={closeModal}
          selectedStory={selectedStory}
        />
      )}
    </section>
  );
}
